import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';
import useDevice from '@hooks/useDevice';
import { Box, Stack } from '@mui/material';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React from 'react';
import FoodListItem from './FoodListItem';
import FoodListTitle from './FoodListTitle';
import FoodListItemSkeleton from './skeleton/FoodListItemSkeleton';
import FoodListTitleSkeleton from './skeleton/FoodListTitleSkeleton';
import FoodAdditionalDrawer from '../food-additional/FoodAdditionalDrawer';
import FoodNoteDialog from '../food-additional/note/FoodNoteDialog';
import FoodSearchBox from './search/FoodSearchBox';

interface FoodListProps {
    restaurantOfferStore: RestaurantOfferStore;
}

const FoodList: React.FC<FoodListProps> = observer(({ restaurantOfferStore }) => {
    const { selectedFoodCategory, foodSearchResult, onFoodSearch, clearFoodSearch, isFoodCategoryLoading, isFoodLoading, onFoodClick } = restaurantOfferStore;

    const { isMobileDevice } = useDevice();

    var foodsToDisplay = foodSearchResult ?? selectedFoodCategory?.foods;

    return (
        <Box width={"100%"}>
            <FoodSearchBox onSearch={onFoodSearch} onClear={clearFoodSearch}/>
            {isFoodCategoryLoading || selectedFoodCategory === undefined
                ? <FoodListTitleSkeleton />
                : <FoodListTitle restaurantOfferStore={restaurantOfferStore} />
            }
            <Stack
                alignItems="center"
                justifyContent="flex-start"
                spacing={{ xs: 1.5, sm: 1.5, md: 2 }}
                useFlexGap
                direction="row"
                flexWrap="wrap"
                display={{ sm: "flex", md: "grid" }}
                gridTemplateColumns={{ sm: "1fr", lg: "repeat(2, minmax(0, 1fr))" }}
                mt={2}>
                {isFoodLoading || isFoodCategoryLoading
                    ? _.map(new Array(6), (item, index) => (
                        <FoodListItemSkeleton key={`food-skeleton-${index}`} />
                    ))
                    : _.map(foodsToDisplay, (food) => (
                        <FoodListItem
                            key={food.id}
                            food={food}
                            onClick={onFoodClick} />
                    ))
                }
            </Stack>
            <FoodAdditionalDrawer restaurantOfferStore={restaurantOfferStore} />
            <FoodNoteDialog restaurantOfferStore={restaurantOfferStore} />
        </Box>
    )
})

export default FoodList;